import EtablissementStatutLicenceSpectacle from '@/generated/controls/etablissement/EtablissementStatutLicenceSpectacle.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementStatutLicenceSpectacle
})
